import React, { FC } from 'react';

import {
  Box,
  Chip,
  FormHelperText,
  InputLabel,
} from '@mui/material';

import strings from '../../../../localization';

import styles from './styles';

interface IBroadcastGroupEmails {
  emails: Array<string>;
  error?: string;
  onRemove: (email: string) => void;
}

const BroadcastGroupEmails: FC<IBroadcastGroupEmails> = ({
  emails,
  error,
  onRemove,
}) =>
  (
    <Box sx={styles.emailsField}>
      <InputLabel>
        {strings.emails}
        <Box component="span" sx={styles.requiredLabel}>*</Box>
      </InputLabel>
      <Box sx={styles.emailChips}>
        {emails.map((email) =>
          (
            <Chip
              key={email}
              label={email}
              onDelete={() => onRemove(email)}
              sx={styles.emailChip}
            />
          ))}
      </Box>
      <FormHelperText error sx={styles.emailError}>
        {error ?? ' '}
      </FormHelperText>
    </Box>
  );

export default BroadcastGroupEmails;
